"use client"

import clsx from "clsx"
import { npPageGapClassName, npPagePtClassName, npPagePxClassName } from "src/components/np-design/components/constants"
import { ProductBreadcrumbsLd } from "src/components/product-details/ProductBreadcrumbsLd"
import { DetailProductData } from "src/data/product-details/types"
import { AdcellProductTag } from "src/integrations/adcell/AdcellProductTag"
import { LinkedData } from "src/seo/LinkedData"
import { createDetailProductLd } from "src/seo/productLd"
import { useTrackViewDetailProduct } from "src/tracking/events"
import { ProductAccordion } from "./ProductAccordion"
import { ProductDimensions } from "./ProductDimensions"
import { ProductGalleries } from "./ProductGalleries"
import { ProductHeroSectionRange } from "./ProductHeroSectionRange"
import { ProductImages } from "./ProductImages"
import { ProductSeoText } from "./ProductSeoText"
import { ProductBuyBox } from "./buyBox/ProductBuyBox"
import { ProductDescription } from "./buyBox/ProductDescription"
import { ProductProvider } from "./context"
import { useResolvedProductData } from "./useResolvedProductData"

export type ProductPageProps = {
  product: DetailProductData
}

export const ProductPage = ({ product }: ProductPageProps) => {
  const resolvedProductData = useResolvedProductData(product)
  const trackingRef = useTrackViewDetailProduct(resolvedProductData)

  return (
    <ProductProvider value={resolvedProductData}>
      <div ref={trackingRef}>
        <div className={npPagePxClassName}>
          <div
            className={clsx(
              npPagePtClassName,
              "mx-auto grid grid-cols-1 grid-rows-[auto_1fr] justify-center gap-10 xl:grid-cols-[640px_auto] xl:flex-row",
            )}
          >
            <div className="mx-auto max-w-full xl:m-0">
              <ProductImages />
            </div>
            <div className="xl:col-start-2 xl:row-span-full">
              <ProductBuyBox />
            </div>
            <div className={clsx(npPageGapClassName, "grid grid-cols-1 content-start")}>
              <ProductDescription />
              <ProductAccordion />
            </div>
          </div>
        </div>

        <ProductHeroSectionRange offset={0} count={2} />
        <ProductDimensions />
        <ProductHeroSectionRange offset={2} />
        <ProductGalleries />
        <ProductSeoText />
      </div>

      {/* TODO upsell accessories on the product detail page */}
      {/* {!!product.accessories?.length && <NpAccessoriesCarousel accessories={product.accessories} />} */}

      <ProductBreadcrumbsLd {...resolvedProductData} />
      <LinkedData data={createDetailProductLd(product)} />
      <AdcellProductTag product={resolvedProductData} />
    </ProductProvider>
  )
}
